import {SxProps} from '@mui/material';

import {matchesBoard} from './MatchesBoard.colors';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';

/** Layout + label size aligned with kanban "Bestätigen" (approve). Reuse on other card CTAs. */
export const kanbanMatchCardPrimaryButtonSizeSx: SxProps = {
  minWidth: 120,
  height: 32,
  px: 1.5,
  fontSize: '12px',
};

export const containerStyles: SxProps = {
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  flexDirection: {xs: 'column', md: 'row'},
  flexWrap: {xs: 'wrap', md: 'nowrap'},
  display: 'flex',
  alignContent: {sm: 'center'},
  width: '100%',
  overflowX: {xs: 'visible', md: 'hidden'},
  pb: 1,
};

export const dividerStyles: SxProps = {
  backgroundColor: orangeColors[4],
  borderRightWidth: 2,
  ml: 1.5,
  borderRadius: 2,
};

export const columnContainerStyles: SxProps = {
  height: '100%',
  borderRadius: '16px',
  border: 'none',
  backgroundColor: 'transparent',
  padding: '16px',
};

export const columnHeaderStyles: SxProps = {
  color: greenColors[700],
  fontWeight: 700,
};

/** Light-mode kanban cards: white surface, no stroke — depth from shadow only. */
export const paperStyles: SxProps = {
  width: '100%',
  minHeight: 0,
  flexShrink: 0,
  borderRadius: '14px',
  padding: '16px',
  height: 'auto',
  marginBottom: 2,
  backgroundColor: 'white',
  border: 'none',
  boxShadow: matchesBoard.cardShadow,
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'white',
    boxShadow: matchesBoard.cardShadowHover,
    transform: 'translateY(-2px)',
  },
};
